import React from 'react'
import {Link} from 'react-router-dom'
import {Nav, Container, Col, NavDropdown} from 'react-bootstrap'
import ProductsGenrateor from '../ProductsGenrateor'

function Navs({setSearch, displayState}) {
    return (
            <Nav variant="pills" defaultActiveKey="/home" className="w-auto d-lg-block d-none">
              <h4 className="mt-2 ps-4" style={{height:"38px", lineHeight:"38px"}}>Categories</h4>
  <Nav.Item className="d-flex flex-column align-items-start justify-contect-between ps-3">
    {
       ProductsGenrateor.reduce((arr, product) => {
        if(!arr.includes(product.tag)) arr.push(product.tag)
        return arr
      }, []).map( tag => <Nav.Link style={{padding:".6rem .20rem", whiteSpace: 'pre'}}>
        <Link className="fs-6 text-secondary text-decoration-none font-weight-bold text-capitalize" to={`/products/${tag}`} onClick={() => setSearch(tag)}><small>- {tag}</small></Link>
        </Nav.Link>
        )
    }
  </Nav.Item>
</Nav>
       
    )
}

export default Navs
